export const CHAT_ITEM_LIST = [
    {
        username: 'Samantha Doe',
        message: 'Lorem ipsum dolor sit amet....',
        time: '12:34 PM',
        id: 1,
    },
    {
        username: "John Doe",
        message: "Lorem ipsum dolor sit amet....",
        time: "12:34 PM",
        id: 2,
    },
    {
        username: "Jane Doe",
        message: "Lorem ipsum dolor sit amet....",
        time: "12:34 PM",
        id: 3,
    }
]